import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { btLayoutSidebarActions } from '@common-reducers/BtLayoutSidebarReducer';

type Props = {
    size?: number
}

export const ChatReminderButton = ({ size }: Props) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    // Use the Provider's store (NOT the extension-store singleton): this
    // component renders both on WhatsApp Web (extension store) and in the
    // Team Inbox dashboard (web store). A direct singleton import dispatches
    // into the wrong store on the dashboard and the sidebar never opens.
    const isRemindersOpen = useAppSelector((state) => {
        const { isOpen, componentToShow } = state.BtLayoutSidebarReducer || ({} as any);
        return !!isOpen && componentToShow === 'Reminders';
    });

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        if (isRemindersOpen) {
            dispatch(btLayoutSidebarActions.closeSidebar());
        } else {
            dispatch(btLayoutSidebarActions.openWithComponent('Reminders'));
        }
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className={`p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors mx-0.5 cursor-pointer hover:text-blue-500 relative ${isRemindersOpen ? 'text-blue-500' : 'text-gray-500'}`}
                        onClick={handleClick}
                    >
                        <svg width={size || 20} height={size || 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                            <path d="M12 2v2"></path>
                        </svg>
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>{t('reminders.createReminder')}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default ChatReminderButton;
